'use client';

import React from 'react';

import Item, { ItemProps } from './Item';

import useTranslation from '../translation/useTranslation';

export type ClaimProps = Partial<ItemProps>;

function Claim({
  id = 'claim',
  title = '',
  icon = <i aria-hidden>support</i>,
  as = 'a',
  href = '/privat/forsikring/meld-skade',
  ...props
}: ClaimProps) {
  const { t } = useTranslation();

  return (
    <Item
      as={as}
      id={id}
      title={title || t('skade.text')}
      icon={icon}
      href={href}
      data-trackid={`link-navbar_make_claim|${title || t('skade.text')}`}
      {...props}
    />
  );
}

export default Claim;
